(() => {
  if (window.__sfCartDrawerReady) return;
  window.__sfCartDrawerReady = true;

  const escapeProductContextHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const collectionLabels = {
    'vibrators-bullets': 'Vibrators',
    'dildos': 'Dildos',
    'male-pleasure': 'Penis Toys',
    'anal-play': 'Anal Toys',
    'cock-rings': 'Cock Rings',
    'strap-ons-harnesses': 'Strap-Ons',
    'bondage-basics': 'Bondage',
    'lubes-essentials': 'Lubes & Body',
    'lingerie': 'Lingerie'
  };

  const labelForHandle = (handle) => collectionLabels[handle] || handle.replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());

  const rememberCollectionContext = (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    const match = location.pathname.match(/\/collections\/([^/]+)/);
    if (!link || !match) return;
    const handle = match[1];
    const heading = document.querySelector('main h1, main [role="heading"]');
    try {
      sessionStorage.setItem('sfCollectionContext', JSON.stringify({
        handle,
        title: heading?.textContent?.trim() || collectionLabels[handle] || handle.replace(/-/g, ' '),
        href: `/collections/${handle}`,
        savedAt: Date.now()
      }));
    } catch (_) {}
  };
  document.addEventListener('click', rememberCollectionContext, true);

  const inferDepartment = (productData) => {
    const source = [productData?.title, productData?.type, ...(Array.isArray(productData?.tags) ? productData.tags : String(productData?.tags || '').split(','))].join(' ').toLowerCase();
    if (/lingerie|teddy|bodystocking|thigh.?high|hosiery|stocking/.test(source)) return ['lingerie', 'Lingerie'];
    if (/lube|lubricant|massage oil|toy cleaner|cleaner/.test(source)) return ['lubes-essentials', 'Lubes & Body'];
    if (/bondage|cuff|restraint|blindfold|gag|paddle|fetish/.test(source)) return ['bondage-basics', 'Bondage'];
    if (/strap.?on|harness/.test(source)) return ['strap-ons-harnesses', 'Strap-Ons'];
    if (/cock ring|penis ring|erection ring/.test(source)) return ['cock-rings', 'Cock Rings'];
    if (/anal|butt plug|prostate|dilator/.test(source)) return ['anal-play', 'Anal Toys'];
    if (/strok|masturbator|penis pump|pocket pussy|male pleasure/.test(source)) return ['male-pleasure', 'Penis Toys'];
    if (/dildo/.test(source)) return ['dildos', 'Dildos'];
    return ['vibrators-bullets', 'Vibrators'];
  };

  const addProductContext = async () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    const existing = document.querySelector('[data-sf-product-context]');

    let context = null;
    const routeCollection = location.pathname.match(/\/collections\/([^/]+)\/products\//);
    if (routeCollection) {
      const handle = routeCollection[1];
      context = { handle, title: labelForHandle(handle), href: `/collections/${handle}` };
    }

    if (!context && document.referrer) {
      try {
        const previous = new URL(document.referrer);
        const previousCollection = previous.origin === location.origin && previous.pathname.match(/\/collections\/([^/]+)/);
        if (previousCollection) {
          const handle = previousCollection[1];
          context = { handle, title: labelForHandle(handle), href: `/collections/${handle}` };
        }
      } catch (_) {}
    }

    if (!context) {
      try {
        const saved = JSON.parse(sessionStorage.getItem('sfCollectionContext') || 'null');
        if (saved?.handle && Date.now() - Number(saved.savedAt || 0) < 30 * 60 * 1000) context = saved;
      } catch (_) {}
    }

    if (existing && context) {
      const back = existing.querySelector('[data-sf-product-back]');
      const backLabel = back?.querySelector('span');
      const crumbLinks = existing.querySelectorAll('.sf-product-context__crumbs a');
      if (back) back.href = context.href;
      if (backLabel) backLabel.textContent = `Back to ${context.title}`;
      if (crumbLinks[1]) {
        crumbLinks[1].href = context.href;
        crumbLinks[1].textContent = context.title;
      }
      return;
    }
    if (existing) return;

    let productData = null;
    try {
      const response = await fetch(`/products/${match[1]}.js`, { headers: { Accept: 'application/json' } });
      if (response.ok) productData = await response.json();
    } catch (_) {}

    if (!context) {
      const [handle, title] = inferDepartment(productData);
      context = { handle, title, href: `/collections/${handle}` };
    }

    const title = productData?.title || document.querySelector('main h1')?.textContent?.trim() || 'Product';
    const wrapper = document.createElement('div');
    wrapper.className = 'sf-product-context sf-product-context--fallback';
    wrapper.setAttribute('data-sf-product-context', '');
    wrapper.innerHTML = `<a class="sf-product-context__back" href="${escapeProductContextHtml(context.href)}" data-sf-product-back><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg><span>Back to ${escapeProductContextHtml(context.title)}</span></a><nav class="sf-product-context__crumbs" aria-label="Breadcrumb"><ol><li><a href="/">Home</a></li><li aria-hidden="true">/</li><li><a href="${escapeProductContextHtml(context.href)}">${escapeProductContextHtml(context.title)}</a></li><li aria-hidden="true">/</li><li aria-current="page"><span>${escapeProductContextHtml(title)}</span></li></ol></nav>`;

    const style = document.createElement('style');
    style.textContent = `.sf-product-context{width:min(calc(100% - 40px),1440px);margin:0 auto;padding:14px 0 12px;display:flex;align-items:center;gap:16px;color:#2a2026}.sf-product-context__back{flex:0 0 auto;min-height:42px;display:inline-flex;align-items:center;gap:7px;padding:8px 14px;border:1px solid rgba(199,53,103,.3);border-radius:999px;background:#fff4f7;color:#7d173d;font-size:14px;font-weight:750;line-height:1.2;text-decoration:none}.sf-product-context__back svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.sf-product-context__crumbs{min-width:0;overflow:hidden}.sf-product-context__crumbs ol{display:flex;align-items:center;gap:8px;min-width:0;margin:0;padding:0;list-style:none;white-space:nowrap;color:#766b71;font-size:13px}.sf-product-context__crumbs a{color:#7d173d;text-decoration:underline;text-underline-offset:3px}.sf-product-context__crumbs li[aria-current=page]{min-width:0;overflow:hidden;text-overflow:ellipsis}.sf-product-context__crumbs li[aria-current=page] span{display:block;overflow:hidden;text-overflow:ellipsis}@media(max-width:749px){.sf-product-context{width:calc(100% - 28px);padding:10px 0 9px;display:block}.sf-product-context__back{min-height:44px;max-width:100%;margin-bottom:8px;padding-inline:12px 16px}.sf-product-context__back span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sf-product-context__crumbs{overflow-x:auto;scrollbar-width:none}.sf-product-context__crumbs::-webkit-scrollbar{display:none}.sf-product-context__crumbs ol{width:max-content;max-width:100%;font-size:12px}.sf-product-context__crumbs li[aria-current=page]{max-width:42vw}}`;
    document.head.appendChild(style);

    const header = document.querySelector('.shopify-section-group-header-group');
    if (header) header.insertAdjacentElement('afterend', wrapper);
    else document.querySelector('main')?.prepend(wrapper);

    wrapper.querySelector('[data-sf-product-back]')?.addEventListener('click', (event) => {
      if (!document.referrer || history.length < 2) return;
      try {
        const previous = new URL(document.referrer);
        if (previous.origin !== location.origin || previous.pathname === location.pathname) return;
        event.preventDefault();
        history.back();
      } catch (_) {}
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addProductContext, { once: true });
  else addProductContext();

  const overlay = document.querySelector('[data-sf-cart-overlay]');
  const drawer = document.querySelector('[data-sf-cart-drawer]');
  const body = document.querySelector('[data-sf-cart-body]');
  const foot = document.querySelector('[data-sf-cart-foot]');
  const subtotal = document.querySelector('[data-sf-cart-subtotal]');
  if (!overlay || !drawer || !body || !foot || !subtotal) return;

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const formatMoney = (cents, currency = 'USD') => {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };

  const updateCount = (count) => {
    document.querySelectorAll('[data-sf-cart-count]').forEach((node) => {
      node.textContent = count;
      node.setAttribute('aria-label', `${count} ${count === 1 ? 'item' : 'items'} in cart`);
    });
  };

  const render = (cart) => {
    updateCount(cart.item_count);
    subtotal.textContent = formatMoney(cart.total_price, cart.currency || 'USD');
    foot.hidden = cart.item_count === 0;
    if (!cart.item_count) {
      body.innerHTML = '<div class="sf-cart-empty"><h3>Your bag is ready when you are.</h3><p>Explore approachable picks, essentials, and favorites—all shipped discreetly.</p><a href="/collections/new-here-start-with-these">Shop Starter Picks</a></div>';
      return;
    }
    body.innerHTML = cart.items.map((item, index) => {
      const image = item.image ? `<img src="${escapeHtml(item.image)}&width=240" alt="" width="92" height="92">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : '';
      return `<article class="sf-cart-line" data-sf-cart-line>
        <a class="sf-cart-line__image" href="${escapeHtml(item.url)}">${image}</a>
        <div class="sf-cart-line__copy"><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>${variant}<span>${formatMoney(item.final_line_price, cart.currency || 'USD')}</span>
          <div class="sf-cart-line__quantity" aria-label="Quantity"><button type="button" data-sf-cart-change="${index + 1}" data-sf-cart-qty="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><b>${item.quantity}</b><button type="button" data-sf-cart-change="${index + 1}" data-sf-cart-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button></div>
        </div>
      </article>`;
    }).join('');
  };

  const refresh = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh cart');
    const cart = await response.json();
    render(cart);
    return cart;
  };

  const open = () => {
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    document.documentElement.classList.add('sf-cart-is-open');
    drawer.focus();
  };

  const close = () => {
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('sf-cart-is-open');
    window.setTimeout(() => { overlay.hidden = true; }, 220);
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-sf-cart-open]');
    if (trigger) {
      event.preventDefault();
      try { await refresh(); open(); } catch (_) { window.location.assign(trigger.href); }
      return;
    }
    if (event.target.closest('[data-sf-cart-close]') || event.target === overlay) { close(); return; }
    const quantity = event.target.closest('[data-sf-cart-change]');
    if (quantity) {
      quantity.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(quantity.dataset.sfCartChange), quantity: Number(quantity.dataset.sfCartQty) })
        });
        if (!response.ok) throw new Error('Unable to update cart');
        render(await response.json());
      } finally { quantity.disabled = false; }
    }
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !overlay.hidden) close(); });
  document.addEventListener('cart:update', () => { window.setTimeout(async () => { try { await refresh(); open(); } catch (_) {} }, 80); });
  refresh().catch(() => {});
})();
